export enum ProfileSuccessCodes {
  MARKETING_PREFERENCE_UPDATED = 'marketin_preference_updated',
}
